import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenav, MatSidenavContainer } from '@angular/material/sidenav';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule, MatRowDef } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ICreateCompanyHoliday } from './interface/create-company-holiday.interface';
//import CompanyHolidaysAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/configurations/company/company-holidays/company-holidays.entity';
import { MatDatepickerModule } from '@angular/material/datepicker';


@Component({
  selector: 'app-add-company-holiday-modal',
  styleUrl: './company-holiday.component.scss',
  templateUrl: './company-holiday.component.html',
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSortModule,
    MatPaginatorModule,
    MatIcon,
    MatSlideToggle,
    MatSelectModule,
    MatOptionModule,
    MatTooltipModule,
    MatExpansionModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    MatRowDef,
    MatSidenav,
    MatSidenavContainer,
    FormsModule,
    MatSelectModule,
    MatTabsModule,
    MatDatepickerModule,
  ],
})
export class AddCompanyHolidayComponent {
  currentCreateCompanyHoliday: ICreateCompanyHoliday = this.initializeCreateCompanyHoliday();
  currentUpdateCompanyHoliday: any | undefined; ////TODO HOLIDAYS CompanyHolidaysAttributes


 isEditMode : boolean;
  constructor(
    // private readonly addressTypeService: PhoneTypeService,
    public dialogRef: MatDialogRef<AddCompanyHolidayComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any 
  ) {
    this.isEditMode = !!data; 
    if (this.isEditMode) {
      this.currentCreateCompanyHoliday = { 
        ...data,
    }; 
    }
  }

  
  ngAfterViewInit(): void {
  }



  private initializeCreateCompanyHoliday(): ICreateCompanyHoliday {
    return {
      date: new Date(),
      description:'',
    };
  }


  save() {
    this.dialogRef.close(this.currentCreateCompanyHoliday);
  }
}
